'use client';
import { Button, Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/navigation';
import { RootState } from '@/lib/redux/store';

const buttonClasses = {
  root: {
    marginTop: '40px',
  },
};

const StartPracticeButton = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const selectedPractices = useSelector((state: RootState) => state.whatToPractice);
  const selectedNumbers = useSelector((state: RootState) => state.selectedNumbers);
  const selectionNotMade = selectedPractices.length === 0 || selectedNumbers.length === 0;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    router.push('/practice');
  };

  return (
    <Grid container>
      <Grid display='flex' justifyContent='center' alignItems='center' size={12}>
        <Button
          sx={{
            ...buttonClasses,
            '&.Mui-disabled': {
              background: '#525252',
              color: '#c0c0c0',
            },
            width: 200,
            margin: 1,
          }}
          variant='contained'
          size='large'
          color='secondary'
          disabled={selectionNotMade}
          onClick={handleClick}
        >
          {' '}
          {t('navbar.start-quiz.link.text')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default StartPracticeButton;
